import { Formik } from 'formik';
import type { Router } from 'next/router';
import { useRouter } from 'next/router';
import React from 'react';
import { useSelector } from 'react-redux';
import { useAppContext } from 'Context/ReactAppContext';
import { PaymentFormikForm } from 'Components/widgets/payment-info/paymentFormik';
import { castAs } from 'Src/types/cast-helpers';
import { submitDelCredereBooking } from './DelCredereBooking.utils';
import { DelCrederePaymentForm } from './DelCrederePaymentForm';
type Props = {
  i18n: I18N;
  renderBottomNavbar: (arg0: unknown) => React.ReactNode;
  selectedProposal: Proposal;
  totalPrice: number;
};
export const DelCredereBooking = ({ i18n, selectedProposal, totalPrice }: Props) => {
  const appContext = useAppContext();
  const router = useRouter();
  const salesmanID = useSelector((state) => state.seller.sellerInfo.salesmanID);
  return (
    <Formik
      initialValues={{
        amountToPay: totalPrice,
        paymentProviderId: '',
        paymentMethodId: '',
        paymentConditionId: '',
        households: [],
        termsAndConditions: {
          donation: false,
        },
        donation: null,
      }}
      onSubmit={() => {
        submitDelCredereBooking({
          appContext,
          router: castAs<Router>(router),
          proposal: selectedProposal,
          salesmanID,
        });
      }}
      validateOnMount
    >
      <PaymentFormikForm>
        <DelCrederePaymentForm
          i18n={i18n}
          paymentSchedules={selectedProposal.households.map(
            ({ paymentSchedule }) => paymentSchedule,
          )}
        />
      </PaymentFormikForm>
    </Formik>
  );
};
